import React from 'react';
import { LinkModel } from '../Types/LinkModel';

interface BrandsBlockProps {
  title?: string;
  brands: [{ link: LinkModel; imageUrl?: string }];
  link?: LinkModel;
  linkText?: string;
}

const BrandsBlock = ({
  title,
  link,
  linkText,
  brands,
}: BrandsBlockProps) => {
  return (
    <div className="container flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h2 className="uppercase">{title}</h2>
        {link && (
          <a className="text-xl underline" href={link.href}>
            {linkText}
          </a>
        )}
      </div>
      <ul className="grid grid-cols-2 items-center justify-center gap-4 md:grid-cols-3 md:gap-6 lg:grid-cols-6">
        {brands.map((brand) => (
          <li key={brand.link.text + brand.link.href}>
            <a
              className="flex justify-center rounded bg-gray-50 p-2"
              href={brand.link.href}
              aria-label={brand.link.text}
            >
              {brand.imageUrl && (
                <img
                  className="h-full max-h-12 w-auto"
                  src={brand.imageUrl}
                  alt={brand.link.text}
                  loading="lazy"
                />
              )}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BrandsBlock;
